/*
 * PF-rekommendationer på produktsidan (plattformen, mig 415).
 *
 * Sektionen related-products renderar VÅR lista (metaobjektet
 * pf_rekommendation) direkt i sidan och lägger Shopifys egna
 * rekommendationer vilande i en <template>. Här avgörs gruppen:
 *   rec       — vår lista (andelen i sektionens inställning, standard 80 %)
 *   kontroll  — Shopifys lista, precis som förut
 *   saknas    — produkten har ingen lista hos oss; Shopifys visas, räknas inte i testet
 * Gruppen är fast per besökare (samma id som hjärtat, localStorage pf-cid).
 *
 * Mätningen går till /apps/pf/rec (App Proxy):
 *   impression  när listan syns på skärmen
 *   click       klick på en produkt i listan, med plats
 *   add_to_cart varukorg på en produkt man kom till via listan (14 dagar)
 * Köpen kopplas via kassaattributet _pf_cid (dolt i kassan).
 *
 * Samtycke (Pandectes → Shopify.customerPrivacy):
 *   analys      → mätningen ovan, besökar-id och kassaattributet
 *   preferenser → besökshistoriken (pf-hist) som personaliseringen ska bygga på
 * Utan samtycke visas vår lista, men ingenting mäts eller sparas.
 *
 * Källan (meta, google_ads, e-post, organisk sök …) läses på besökets första
 * sida och skickas med varje visning — resultaten delas upp per källa.
 */
(function () {
  "use strict";

  var ENDPOINT = "/apps/pf/rec";
  var CID_KEY = "pf-cid";
  var ATTR_KEY = "pf-rec-attr";
  var CART_FLAG = "pf-rec-cart-cid";
  var ATTR_DAYS = 14;
  var SRC_KEY = "pf-src";
  var HIST_KEY = "pf-hist";
  var HIST_MAX = 80;

  function clientId() {
    try {
      var id = localStorage.getItem(CID_KEY);
      if (!id) {
        id = window.crypto && crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
        localStorage.setItem(CID_KEY, id);
      }
      return id;
    } catch (e) {
      return null;
    }
  }

  /* FNV-1a — stabil fördelning 0–99 per besökare. */
  function bucket(id) {
    var h = 0x811c9dc5;
    for (var i = 0; i < id.length; i++) {
      h ^= id.charCodeAt(i);
      h = Math.imul(h, 0x01000193);
    }
    return (h >>> 0) % 100;
  }

  function device() {
    return window.matchMedia && window.matchMedia("(max-width: 749px)").matches ? "mobile" : "desktop";
  }

  function send(body) {
    try {
      return fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        keepalive: true,
        credentials: "same-origin",
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    } catch (e) {
      return Promise.resolve(null);
    }
  }

  function readAttr() {
    try {
      var a = JSON.parse(localStorage.getItem(ATTR_KEY) || "{}");
      var cutoff = Date.now() - ATTR_DAYS * 864e5;
      Object.keys(a).forEach(function (k) { if (!a[k] || a[k].ts < cutoff) delete a[k]; });
      return a;
    } catch (e) {
      return {};
    }
  }

  function writeAttr(a) {
    try { localStorage.setItem(ATTR_KEY, JSON.stringify(a)); } catch (e) { /* privat läge */ }
  }

  /* Besökar-id:t på varukorgen, så att köpet går att koppla (dolt attribut). */
  function tagCart(cid) {
    try {
      if (sessionStorage.getItem(CART_FLAG) === cid) return;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      fetch(root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { _pf_cid: cid } }),
        credentials: "same-origin",
      }).then(function (r) { if (r.ok) sessionStorage.setItem(CART_FLAG, cid); }).catch(function () {});
    } catch (e) { /* ingen sessionStorage */ }
  }


  /* Samtycke via Shopifys Customer Privacy API (Pandectes synkar dit). Saknas
     API:t (t.ex. blockerat) räknas det som inget samtycke. */
  function privacy() {
    return (window.Shopify && window.Shopify.customerPrivacy) || null;
  }
  function consent() {
    var p = privacy();
    if (!p) return { analytics: false, preferences: false, known: false };
    try {
      return {
        analytics: !!(p.analyticsProcessingAllowed && p.analyticsProcessingAllowed()),
        preferences: !!(p.preferencesProcessingAllowed && p.preferencesProcessingAllowed()),
        known: true,
      };
    } catch (e) {
      return { analytics: false, preferences: false, known: false };
    }
  }
  /* Väntar in API:t (laddas av Shopify/Pandectes), högst ~2 s. */
  function whenPrivacy(cb) {
    if (privacy()) return cb();
    var done = false;
    function go() { if (!done) { done = true; cb(); } }
    try {
      if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () { go(); });
      }
    } catch (e) { /* fortsätt */ }
    setTimeout(go, 2000);
  }

  /* Källan när besöket började: klick-id:n först, sedan utm, sedan referrer. */
  function detectSource() {
    var q = new URLSearchParams(location.search);
    var src = (q.get("utm_source") || "").toLowerCase();
    var med = (q.get("utm_medium") || "").toLowerCase();
    if (q.get("fbclid") || /^(facebook|instagram|meta|fb|ig)$/.test(src)) return "meta";
    if (q.get("gclid") || q.get("gbraid") || q.get("wbraid") || (/google/.test(src) && /(cpc|ppc|paid|pmax|shopping)/.test(med))) return "google_ads";
    if (/(email|e-post|newsletter|klaviyo)/.test(med) || /(klaviyo|shopify_email|newsletter)/.test(src)) return "email";
    var ref = "";
    try { ref = document.referrer ? new URL(document.referrer).hostname : ""; } catch (e) { ref = ""; }
    if (!ref) return "direct";
    if (ref === location.hostname || /haileysjewelryhouse\./.test(ref)) return "internal";
    if (/(^|\.)(google|bing|duckduckgo|yahoo|ecosia)\./.test(ref)) return "organic_search";
    if (/(facebook|instagram|pinterest|tiktok|linkedin|t\.co|x\.com)/.test(ref)) return "social";
    return "other";
  }
  /* Första sidan i besöket avgör; följande sidvisningar (internal) behåller den. */
  function sessionSource() {
    try {
      var s = sessionStorage.getItem(SRC_KEY);
      if (s) return s;
      s = detectSource();
      sessionStorage.setItem(SRC_KEY, s);
      return s;
    } catch (e) {
      return detectSource();
    }
  }

  /* Besökshistorik (bara med samtycke till preferenser): produkt → [antal, senast]. */
  function recordView(productId) {
    try {
      var h = JSON.parse(localStorage.getItem(HIST_KEY) || "{}");
      var cur = h[productId] || [0, 0];
      h[productId] = [cur[0] + 1, Date.now()];
      var keys = Object.keys(h);
      if (keys.length > HIST_MAX) {
        keys.sort(function (a, b) { return h[a][1] - h[b][1]; });
        keys.slice(0, keys.length - HIST_MAX).forEach(function (k) { delete h[k]; });
      }
      localStorage.setItem(HIST_KEY, JSON.stringify(h));
    } catch (e) { /* privat läge */ }
  }

  function idsOf(list, attr) {
    var raw = list && list.getAttribute(attr || "data-pf-ids");
    return raw ? raw.split(",").filter(Boolean) : [];
  }

  /* Loggar visningen när listan syns, och klick i den därefter. */
  /* Versionsfältet bär alla listornas algoritmer ("liknande-v1+matcha-v1") —
     varje visning loggar den som gäller ytan. */
  function algoFor(version, surface) {
    var prefix = surface.indexOf("matcha") === 0 ? "matcha" : "liknande";
    var parts = String(version || "").split("+");
    for (var i = 0; i < parts.length; i++) if (parts[i].indexOf(prefix) === 0) return parts[i];
    return undefined;
  }

  function track(root, list, arm, cid, ctx, opt) {
    opt = opt || {};
    var surface = opt.surface || "liknande";
    var cardSel = opt.cardSelector || "product-card";
    var ids = opt.noItems ? [] : idsOf(list, opt.idsAttr);
    if (!ids.length && !opt.noItems) return;
    var impression = null;
    var logged = false;

    function logImpression() {
      if (logged) return;
      logged = true;
      impression = send({
        action: "impression", surface: surface, arm: arm,
        algo_id: arm === "rec" && !opt.noAlgo ? algoFor(ctx.version, surface) : undefined,
        context: opt.context || undefined,
        anchor: ctx.anchor, items: ids, source: ctx.source,
        client_id: cid, market: ctx.market, device: device(),
      }).then(function (res) { return res && res.ok ? res.id : null; });
    }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { logImpression(); io.disconnect(); }
        });
      }, { threshold: opt.noItems ? 0 : 0.3 }); // kontrollen har ingen yta att mäta andel av
      io.observe(opt.noItems ? root : list);
    } else {
      logImpression();
    }

    list.addEventListener("click", function (ev) {
      var link = ev.target.closest && ev.target.closest("a[href]");
      var card = ev.target.closest && ev.target.closest(cardSel);
      if (!link || !card) return;
      var cards = Array.prototype.slice.call(list.querySelectorAll(cardSel));
      var pos = cards.indexOf(card) + 1;
      var pid = ids[pos - 1];
      if (!pos || !pid) return;
      logImpression(); // klick utan att IntersectionObserver hunnit
      var attr = readAttr();
      impression.then(function (impId) {
        if (!impId) return;
        attr[pid] = { imp: impId, pos: pos, arm: arm, ts: Date.now() };
        writeAttr(attr);
        send({ action: "click", impression_id: impId, product: pid, position: pos, client_id: cid, market: ctx.market, device: device() });
      });
    });
  }

  /* Varukorg på en produkt man kom till via en lista (produktsidans egna köpknapp
     skickar pf:cart-add, temats snabbköp variant:add). */
  function watchCart(cid, ctx) {
    var attr = readAttr();
    var hit = attr[ctx.anchor];
    if (!hit) return;
    var sent = false;
    function onAdd() {
      if (sent) return;
      sent = true;
      send({ action: "add_to_cart", impression_id: hit.imp, product: ctx.anchor, position: hit.pos, client_id: cid, market: ctx.market, device: device() });
    }
    document.addEventListener("variant:add", onAdd);
    document.addEventListener("pf:cart-add", onAdd);
  }

  function waitForList(root, cb) {
    var found = root.querySelector("product-list[data-pf-ids]");
    if (found) return cb(found);
    var mo = new MutationObserver(function () {
      var l = root.querySelector("product-list[data-pf-ids]");
      if (l) { mo.disconnect(); cb(l); }
    });
    mo.observe(root, { childList: true, subtree: true });
  }

  /* ── Flikarna under produkten (mig 424) ──────────────────────────────────
     Flik 1 = Liknande (A/B-testet ovan). Flik 2–4 = Senast visade (temats egen
     historik, theme:recently-viewed-products, laddas här) eller en kollektion
     (renderad av temat). Visningen loggas när fliken syns — de syns bara efter
     ett klick. UI:t körs alltid; mätningen bara med samtycke (onList = null). */
  var RECENT_KEY = "theme:recently-viewed-products";

  function whenEl(root, sel, cb) {
    var found = root.querySelector(sel);
    if (found) return cb(found);
    var mo = new MutationObserver(function () {
      var el = root.querySelector(sel);
      if (el) { mo.disconnect(); cb(el); }
    });
    mo.observe(root, { childList: true, subtree: true });
  }

  function syncTabLink(wrap) {
    var tabs = wrap.querySelector("featured-collections-tabs");
    // Länken står i sektionsrubriken (i höjd med "Rekommenderade produkter").
    var link = (wrap.closest(".section-stack") || wrap.parentNode).querySelector("[data-pf-tab-link]");
    if (!tabs || !link) return;
    var sel = tabs.querySelector('[role="tab"][aria-selected="true"]');
    var panel = sel && document.getElementById(sel.getAttribute("aria-controls"));
    var url = panel && panel.getAttribute("data-url");
    if (url) { link.setAttribute("href", url); link.hidden = false; } else { link.hidden = true; }
  }

  function loadRecent(list, tabBtn, done) {
    var ids;
    try { ids = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]"); } catch (e) { ids = []; }
    var ex = String(list.getAttribute("data-exclude") || "");
    var n = parseInt(list.getAttribute("data-count") || "10", 10);
    // Några extra: sålda filtreras bort i pf-product-cards.
    ids = ids.filter(function (i) { return String(i) !== ex; }).slice(0, n + 6);
    if (!ids.length) return;
    var q = ids.map(function (i) { return "id:" + i; }).join(" OR ");
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    fetch(root + "search?type=product&q=" + encodeURIComponent(q) + "&section_id=pf-product-cards", { priority: "low" })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .then(function (html) {
        if (!html) return;
        var box = new DOMParser().parseFromString(html, "text/html").querySelector("[data-pf-cards]");
        if (!box) return;
        var cards = Array.prototype.slice.call(box.children, 0, n);
        if (!cards.length) return;
        list.replaceChildren.apply(list, cards.map(function (c) { return document.importNode(c, true); }));
        list.setAttribute("data-pf-tab-ids", (box.getAttribute("data-ids") || "").split(",").slice(0, n).join(","));
        if (tabBtn) tabBtn.hidden = false;
        done(list);
      })
      .catch(function () {});
  }

  function setupTabs(root, onList) {
    if (root.__pfTabs) return;
    root.__pfTabs = true;
    whenEl(root, "[data-pf-tabs]", function (wrap) {
      var scope = wrap.parentNode;
      var ready = function (list) { if (onList) onList(list); };
      wrap.addEventListener("click", function (ev) {
        if (ev.target.closest && ev.target.closest('[role="tab"]')) setTimeout(function () { syncTabLink(wrap); }, 0);
      });
      scope.querySelectorAll("product-list[data-pf-surface]").forEach(function (list) {
        if (list.hasAttribute("data-pf-recent")) loadRecent(list, wrap.querySelector("[data-pf-recent-tab]"), ready);
        else if (list.getAttribute("data-pf-tab-ids")) ready(list);
      });
    });
  }

  function tabTracker(root, cid, ctx) {
    return function (list) {
      track(root, list, "rec", cid, ctx, {
        surface: list.getAttribute("data-pf-surface"),
        context: list.getAttribute("data-pf-context"),
        idsAttr: "data-pf-tab-ids",
        noAlgo: true,
      });
    };
  }

  function init(root) {
    if (root.__pfRec) return;
    root.__pfRec = true;
    var ctx = {
      anchor: root.getAttribute("data-pf-anchor"),
      version: root.getAttribute("data-pf-version"),
      market: root.getAttribute("data-pf-market") || undefined,
      source: sessionSource(),
    };
    var share = parseInt(root.getAttribute("data-pf-share") || "80", 10);
    var mode = root.getAttribute("data-pf-mode"); // "rec" (vi har en lista) eller "saknas"

    whenPrivacy(function () {
      var c = consent();
      if (c.preferences && ctx.anchor) recordView(ctx.anchor);
      if (!c.analytics) {
        // Inget samtycke till analys: vår lista (standard), ingen grupp, ingen mätning.
        if (mode === "rec") {
          var tplX = root.querySelector("template[data-pf-rec-control]");
          if (tplX) tplX.remove();
        }
        setupTabs(root, null);
        return;
      }
      var cid = clientId();
      if (!cid) { setupTabs(root, null); return; }
      tagCart(cid);
      watchCart(cid, ctx);

      if (mode !== "rec") {
        waitForList(root, function (l) { track(root, l, "saknas", cid, ctx); });
        setupTabs(root, tabTracker(root, cid, ctx));
        return;
      }
      if (bucket(cid) < share) {
        var ours = root.querySelector("[data-pf-rec-ours]");
        waitForList(ours || root, function (l) { track(root, l, "rec", cid, ctx); });
      } else {
        var ours2 = root.querySelector("[data-pf-rec-ours]");
        if (ours2) ours2.remove();
        var tpl = root.querySelector("template[data-pf-rec-control]");
        if (tpl) root.appendChild(tpl.content.cloneNode(true)); // Shopifys laddar som vanligt
        waitForList(root, function (l) { track(root, l, "kontroll", cid, ctx); });
      }
      // Efter gruppvalet: i kontrollen finns flikarna först när Shopifys lista laddats.
      setupTabs(root, tabTracker(root, cid, ctx));
    });
  }


  /* ── Matcha med (mig 419–420) ────────────────────────────────────────────
     Egen A/B-fördelning (oberoende av Liknande): 20 % ser inget block. */
  function initMatcha(root) {
    if (root.__pfMatcha) return;
    root.__pfMatcha = true;
    var ctx = {
      anchor: root.getAttribute("data-pf-anchor"),
      version: root.getAttribute("data-pf-version"),
      market: root.getAttribute("data-pf-market") || undefined,
      source: sessionSource(),
    };
    var share = parseInt(root.getAttribute("data-pf-share") || "80", 10);
    var el = root.querySelector('[data-pf-matcha-block="matcha"]');
    if (!el) return;

    whenPrivacy(function () {
      var c = consent();
      var cid = c.analytics ? clientId() : null;
      if (!cid) { el.hidden = false; return; } // utan samtycke: blocket, ingen mätning
      tagCart(cid);
      var opt = { surface: "matcha", cardSelector: ".product-cross-sell" };
      if (bucket(cid + "|matcha") < share) {
        el.hidden = false;
        track(root, el, "rec", cid, ctx, opt);
      } else {
        // Kontroll: inget block — men exponeringen loggas så att gruppen kan jämföras.
        opt.noItems = true;
        track(root, el, "kontroll", cid, ctx, opt);
      }
    });
  }

  function boot() {
    document.querySelectorAll("[data-pf-rec]").forEach(init);
    document.querySelectorAll("[data-pf-matcha]").forEach(initMatcha);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
